<app-dialog-container
  [title]="data.title"
  [isValid]="form.valid"
  (confirmButtonHandler)="save()"
  [confirmButtonText]="data.confirmButtonText"
>
  <span class="text">{{ data.text }}</span>
  <app-ui-text-area
    [label]="'comment' | translate"
    [control]="form.comment"
    [required]="!data.isOptional"
  ></app-ui-text-area>

  <app-shared-ui-checkbox
    [label]="'setNotificationRecipients' | translate"
    [control]="form.useCustomRecipients"
  ></app-shared-ui-checkbox>

  @if (form.useCustomRecipients.value) {
    <app-ui-select-group
      [label]="'customNotificationRecipients' | translate"
      [control]="form.customNotificationRecipients"
      [optionGroups]="notificationOptionGroups"
      [isMultiple]="true"
      [returnWholeObject]="true"
      [selectAll]="true"
    ></app-ui-select-group>
  }
</app-dialog-container>
